import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
// Type definitions for paint metrics

// Main function returns compact nested format
export default function getPaintMetrics(_x, _x2) {
  return _getPaintMetrics.apply(this, arguments);
}

// Helper function to get paint metrics in legacy colon format for backward compatibility
function _getPaintMetrics() {
  _getPaintMetrics = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(type, end) {
    var paint, paintEntries, lcp;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(type !== 'page_load')) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", {});
        case 2:
          paint = {};
          paintEntries = performance.getEntriesByType('paint');
          paintEntries.forEach(function (entry) {
            if (entry.name === 'first-paint') {
              paint.fp = Math.round(entry.startTime);
            }
            if (entry.name === 'first-contentful-paint') {
              paint.fcp = Math.round(entry.startTime);
            }
          });

          // Get LCP using PerformanceObserver
          _context.next = 7;
          return new Promise(function (resolve) {
            // Check if we already have LCP entries
            var existingEntries = performance.getEntriesByType('largest-contentful-paint');
            var lastEntry = existingEntries.reduce(function (agg, entry) {
              if (entry.startTime <= end && (agg === null || agg.startTime < entry.startTime)) {
                return entry;
              }
              return agg;
            }, null);
            if (lastEntry) {
              resolve(lastEntry.startTime);
              return;
            }
            var observer = new PerformanceObserver(function (list) {
              var entries = Array.from(list.getEntries());
              var lastEntry = entries.reduce(function (agg, entry) {
                if (entry.startTime <= end && (agg === null || agg.startTime < entry.startTime)) {
                  return entry;
                }
                return agg;
              }, null);
              clearTimeout(timeoutId);
              observer.disconnect();
              if (lastEntry) {
                resolve(lastEntry.startTime);
              } else {
                resolve(null);
              }
            });
            observer.observe({
              type: 'largest-contentful-paint',
              buffered: true
            });
            var timeoutId = setTimeout(function () {
              observer.disconnect();
              resolve(null);
            }, 200);
          });
        case 7:
          lcp = _context.sent;
          if (lcp) {
            paint.lcp = Math.round(lcp);
          }
          return _context.abrupt("return", paint);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getPaintMetrics.apply(this, arguments);
}
export function getPaintMetricsToLegacyFormat(_x3, _x4) {
  return _getPaintMetricsToLegacyFormat.apply(this, arguments);
}
function _getPaintMetricsToLegacyFormat() {
  _getPaintMetricsToLegacyFormat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(type, end) {
    var paint, legacyFormat;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return getPaintMetrics(type, end);
        case 2:
          paint = _context2.sent;
          legacyFormat = {};
          if (paint.fp !== undefined) {
            legacyFormat['metric:fp'] = paint.fp;
          }
          if (paint.fcp !== undefined) {
            legacyFormat['metric:fcp'] = paint.fcp;
          }
          if (paint.lcp !== undefined) {
            legacyFormat['metric:lcp'] = paint.lcp;
          }
          return _context2.abrupt("return", legacyFormat);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getPaintMetricsToLegacyFormat.apply(this, arguments);
}